export const ENTRYPOINT = 'https://api.app.bbsperanta.ro';



// WEBPACK FOOTER //
// ./src/config/entrypoint.js